import { render, staticRenderFns } from "./NotificationsListPanel.vue?vue&type=template&id=727eb4b1&scoped=true&"
import script from "./NotificationsListPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationsListPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727eb4b1",
  null
  
)

export default component.exports